import gql from 'graphql-tag';
const PROCESS_DEVICE_IDS = gql`
  mutation processDeviceIds($orgID: ID!, $emailListIds: [ID]!, $dsp: String!) {
    processDeviceIds(data: { orgID: $orgID, emailListIds: $emailListIds, dsp: $dsp })
  }
`;

export default PROCESS_DEVICE_IDS;
